import React from 'react'
import { MorphReplace } from 'react-svg-morph'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      class="design-iconfont"
    >
      <path
        d="M8,9 C9.40584586,9 10.7269954,9.36262789 11.875014,9.999449 L11.885,10 L12.4565011,10.2862457 C12.7901689,10.4574447 13,10.8009441 13,11.1759685 L13,13 C13,13.5522847 12.5522847,14 12,14 L4,14 C3.44771525,14 3,13.5522847 3,13 L3,11.1762791 C3,10.8012353 3.20985249,10.4577217 3.54354665,10.2865317 L4.121,10 L4.126,10 L4.27425568,9.91871002 C5.38694865,9.33206823 6.65469498,9 8,9 Z M8,10 C6.51283435,10 5.13398645,10.4637634 4.00018867,11.2545577 L4,13 L12,13 L12,11.254 L11.7546064,11.0910819 C10.6696323,10.4002347 9.38155606,10 8,10 Z M8,2.49576492 C6.34314575,2.49576492 5,3.83891067 5,5.49576492 C5,7.15261916 6.34314575,8.49576492 8,8.49576492 C9.65685425,8.49576492 11,7.15261916 11,5.49576492 C11,3.83891067 9.65685425,2.49576492 8,2.49576492 Z M8,3.49576492 C9.1045695,3.49576492 10,4.39119542 10,5.49576492 C10,6.60033441 9.1045695,7.49576492 8,7.49576492 C6.8954305,7.49576492 6,6.60033441 6,5.49576492 C6,4.39119542 6.8954305,3.49576492 8,3.49576492 Z"
        fill-rule="evenodd"
        fill-opacity=".9"
      />
    </svg>
  )
}

const LoginUserNameIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

export default LoginUserNameIcon
